import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tab-wr"
}
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = { class: "borrow-header" }
const _hoisted_4 = { class: "loan-amount" }
const _hoisted_5 = { class: "repayments-wr" }
const _hoisted_6 = { class: "default-form" }
const _hoisted_7 = { class: "buttons-section section-result mb-col" }
const _hoisted_8 = { class: "input-wr borrow-calculator" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "input-wr no-margin borrow-calculator" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "input-wr no-margin borrow-calculator" }
const _hoisted_13 = ["onChange", "value"]
const _hoisted_14 = { class: "actions-wr" }
const _hoisted_15 = { class: "estimated-repayments-wr" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "default-form inputs" }
const _hoisted_18 = { class: "input-wr no-margin" }
const _hoisted_19 = { class: "input dropdown-input" }
const _hoisted_20 = { class: "input-wr no-margin" }
const _hoisted_21 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "subtitle" }, "You could borrow up to", -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString($setup.result?.LoanAmountString), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title" }, "Your repayments", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label start" }, "Loan Amount", -1)),
                _createElementVNode("input", {
                  class: "input",
                  disabled: "",
                  type: "text",
                  value: $setup.result?.LoanAmountString,
                  placeholder: "Loan amount"
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label start" }, "Loan Term", -1)),
                _createElementVNode("input", {
                  class: "input",
                  type: "text",
                  disabled: "",
                  value: $setup.props.form?.LoanTerm,
                  placeholder: "Loan term"
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label start" }, "Interest Rate", -1)),
                _createElementVNode("input", {
                  class: "input",
                  onChange: (e) => $setup.updateFormInput(e, $setup.BorrowCalculatorFields.INTEREST_RATE),
                  type: "text",
                  value: `${$setup.props.form?.InterestRate}%`,
                  placeholder: "Interest Rate"
                }, null, 40, _hoisted_13)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[9] || (_cache[9] = _createElementVNode("button", { class: "button button-icon-primary-2 hidden" }, "Speak with a broker", -1)),
            _createElementVNode("div", _hoisted_15, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "Estimated Repayments:", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString($setup.getRepaymentByFre($setup.props.formCalculatorOptions?.repaymentFre, $setup.result)), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode($setup["DropDown"], null, {
                  control: _withCtx(() => [
                    _createElementVNode("button", _hoisted_19, _toDisplayString($setup.props.formCalculatorOptions?.repaymentFre), 1)
                  ]),
                  dropdown: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateFormCalculatorOptions($setup.CalculatorOptionsFields.REPAYMENT_FRE, $setup.RepaymentFre.WEEKLY)))
                      }, "weekly"),
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateFormCalculatorOptions($setup.CalculatorOptionsFields.REPAYMENT_FRE, $setup.RepaymentFre.FORTNIGHTLY)))
                      }, "fortnightly"),
                      _createElementVNode("li", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateFormCalculatorOptions($setup.CalculatorOptionsFields.REPAYMENT_FRE, $setup.RepaymentFre.MONTHLY)))
                      }, "monthly")
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode($setup["DropDown"], null, {
                  control: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("button", { class: "input dropdown-input" }, "Assumptions", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_21))
}